import { Check, Close } from '@mui/icons-material';
import { Box, List, ListItem, Typography } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../StructuredContentRenderer';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
};

export const DefaultProsAndCons = ({ prosList, consList }: Props) => {
  const hasPros = prosList && prosList.length > 0;
  const hasCons = consList && consList.length > 0;

  if (!hasPros && !hasCons) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
        gap: 4,
        svg: {
          height: 22,
          width: 22,
        },
      }}
    >
      {hasPros && (
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="textLargeBold"
            component="h2"
            sx={{
              display: 'block',
              borderBottom: '2px solid',
              borderColor: 'greens.main',
              marginBottom: 2,
              paddingBottom: 1,
            }}
          >
            Pros
          </Typography>
          <List sx={{ listStyleType: 'disc', p: 0 }}>
            {prosList.map((bullet, index) => (
              <ListItem
                disablePadding
                key={`bullet-${index}`}
                sx={{ paddingY: 0.5, display: 'flex', alignItems: 'flex-start', gap: 2 }}
              >
                <Check color="success" />{' '}
                {typeof bullet === 'string' ? bullet : <StructuredContentRenderer doc={bullet} />}
              </ListItem>
            ))}
          </List>
        </Box>
      )}
      {hasCons && (
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="textLargeBold"
            component="h2"
            sx={{
              display: 'block',
              borderBottom: '2px solid',
              borderColor: 'reds.main',
              marginBottom: 2,
              paddingBottom: 1,
            }}
          >
            Cons
          </Typography>
          <List sx={{ listStyleType: 'disc', p: 0 }}>
            {consList.map((bullet, index) => (
              <ListItem
                disablePadding
                key={`bullet-${index}`}
                sx={{ paddingY: 0.5, display: 'flex', alignItems: 'flex-start', gap: 2 }}
              >
                <Close color="error" />{' '}
                {typeof bullet === 'string' ? bullet : <StructuredContentRenderer doc={bullet} />}
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};
